module.exports = __webpack_public_path__ + "media/images/icon-text-39e5373e.svg";